import { render } from "./AlertaErroContaCadastrada.vue?vue&type=template&id=0354a0f6&scoped=true&ts=true"
import script from "./AlertaErroContaCadastrada.vue?vue&type=script&lang=ts"
export * from "./AlertaErroContaCadastrada.vue?vue&type=script&lang=ts"

import "./AlertaErroContaCadastrada.vue?vue&type=style&index=0&id=0354a0f6&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0354a0f6"]])

export default __exports__